import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import DataTableModule from '@/__core/layout/module/DataTableModule';

interface FinancialOverviewRow4Props {
  row4Data: Record<string, string | number | null>[];
  row4Columns: any[];
  row4GroupHeaderRows: Array<Array<{ label: string; colSpan: number; align?: 'left' | 'center' | 'right' }>>;
}

export default function FinancialOverviewRow4({
  row4Data,
  row4Columns,
  row4GroupHeaderRows,
}: FinancialOverviewRow4Props) {
  return (
    <Grid size={{ xs: 12 }} sx={{ minWidth: 0 }}>
      <Typography variant='h6' gutterBottom>
        Tỷ lệ chi phí / Doanh thu
      </Typography>
      <Box sx={{ mt: 1, width: '100%', maxWidth: '100%', overflow: 'visible' }}>
        <DataTableModule
          data={row4Data}
          columns={row4Columns}
          tableLayout='fixed'
          tableSx={{
            minWidth: 'max-content',
            width: 'max-content',
          }}
          tableContainerSx={{
            overflowX: 'auto',
          }}
          groupHeaderRows={row4GroupHeaderRows}
          onRowSelect={() => undefined}
          onSelectAll={() => undefined}
          getRowId={(row) => String((row as any).id || '')}
          isRowSelected={() => false}
          areAllRowsSelected={false}
          areSomeRowsSelected={false}
          showCheckbox={false}
          reserveLeftFilterSpace={false}
        />
      </Box>
    </Grid>
  );
}
